import React from 'react';
import * as routes from 'app/routes';
import Back from 'common/Back';
import styles from './Insurance.module.css';
import SubscriptionSwitcher from 'subscriptions/SubscriptionSwitcher';

import InsuranceInfo from 'insurance/InsuranceInfo/bypassed';

const Insurance = ({ subId, sku, insPlanId, ConfirmInsurance }) => (
  <div>
    <SubscriptionSwitcher
      bypassedSubId={subId}
      sprintRoute={routes.sprintInsurance}
      bypassedRoute={routes.bypassedInsurance}
      quickRoute={routes.quickSubscription}
    />
    <div className={styles.Back}>
      <Back to={routes.bypassedSubscription(subId)} />
    </div>
    <h1>
      Your Device Protection Details
    </h1>
    <InsuranceInfo bypassedSubId={subId} />
  </div>
)

export default Insurance;

